import * as React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";
import { BarChart3 } from "lucide-react";

const SingleLineChart = ({ data }) => {
  const hasData =
    data &&
    Array?.isArray(data?.labels) &&
    Array?.isArray(data?.data) &&
    data?.labels?.length > 0;

  if (!hasData) {
    return (
      <div className="w-full h-[250px] flex flex-col items-center justify-center border border-gray-200 rounded-lg bg-gray-50">
        <BarChart3 className="w-10 h-10 text-[#074043] mb-2" />
        <p className="text-[#074043] text-lg">No data available</p>
      </div>
    );
  }

  // ✅ Transform API structure into recharts structure
  const chartData = data?.labels?.map((label, index) => ({
    month: label,
    count: data?.data[index],
  }));

  return (
    <ResponsiveContainer width="100%" height={250}>
      <LineChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 0, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" axisLine={{ stroke: "#D9D9D9" }}>
          <Label
            value={data?.bucket === "week" ? "Weeks" : "Months"}
            position="insideBottom"
            offset={-10}
          />
        </XAxis>
        <YAxis
          domain={[0, 100]}
          ticks={[0, 25, 50, 75, 100]}
          axisLine={{ stroke: "#D9D9D9" }}
        />
        <Tooltip />
        <Line
          type="linear"
          dataKey="count"
          stroke="#074073"
          strokeWidth={1}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SingleLineChart;
